import {
  DEFAULT_ZOOM,
  mapCenterCoorAtom,
  mapZoomLevelAtom,
  selectedCarListAtom,
  timeLineChgArrAtom,
} from '@/commons/constants';

import { atom, useAtom, useAtomValue } from 'jotai';
import * as _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { InfoWindow, Container as MapDiv, NaverMap } from 'react-naver-maps';
import RoutingLine from './RoutingLine';
import RoutingMarker from './RoutingMarker';
import StartEndMarker from './StartEndMarker';
import CustomTooltip, { HtmlTooltip } from './tooltip';
import { TimeLine } from '@/types/result';

export const tooltipAtom = atom<any>();

export default function RouteMap() {
  const selectedCarList = useAtomValue(selectedCarListAtom);
  const copyArray = useAtomValue(timeLineChgArrAtom);
  const tooltip = useAtomValue(tooltipAtom);

  const mapCenterCoor = useAtomValue(mapCenterCoorAtom);
  const [mapZoomLevel, setMapZoomLevel] = useAtom(mapZoomLevelAtom);

  const [showList, setShowList] = useState([]);
  const [map, setMap] = useState<any>(null);
  const [infoWindow, setInfoWindow] = useState<any>(null);

  useEffect(() => {
    if (mapZoomLevel) {
      map && map.setZoom(mapZoomLevel, true);
    } else {
      setMapZoomLevel(DEFAULT_ZOOM);
    }
  }, [mapZoomLevel]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (selectedCarList && copyArray && copyArray.length > 0) {
        const tempList: TimeLine[] = selectedCarList.map((item: number) => {
          return _.find(copyArray, ['car.car_seq', item]);
        });
        setShowList(tempList);
      } else if (!copyArray || copyArray.length == 0) {
        setShowList(undefined);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [selectedCarList, copyArray]);

  //INFOWINDOW(추후 사용될 여지가 있어서 사용법 남겨둠)
  // useEffect(() => {
  //   if (destDetail) {
  //     infoWindow?.setContent(`<div>${destDetail.sCustomerNm}</div>`);
  //     infoWindow?.open(map, destDetail.sCoor);
  //   } else {
  //     infoWindow?.close();
  //   }
  // }, [destDetail]);

  const handleZoomLevelChange = useCallback(
    _.debounce((level: number) => setMapZoomLevel(level), 150),
    [],
  );

  return (
    <HtmlTooltip title={tooltip ? <CustomTooltip /> : undefined} followCursor>
      <MapDiv style={{ width: '100%', height: '100%' }}>
        <NaverMap
          center={mapCenterCoor}
          defaultZoom={DEFAULT_ZOOM}
          ref={setMap}
          baseTileOpacity={1}
          background="white"
          tileSpare={7}
          onZoomChanged={(param) => handleZoomLevelChange(param)}
        >
          {showList && (
            <>
              <RoutingLine list={showList} />
              <RoutingMarker list={showList} />
              <StartEndMarker list={showList} />
            </>
          )}
          {/* 현 버전에서 사용안함 추후사용될 가능성이 있어서 남겨둠 */}
          {/* <InfoWindow ref={setInfoWindow} content={''} /> */}
        </NaverMap>
      </MapDiv>
    </HtmlTooltip>
  );
}
